import React from "react";
import { useHistory, withRouter } from "react-router-dom";
import Header_component from "../../../../structure_components/desktop_screens/header_component/header_component";
import Footer_component from "../../../../structure_components/desktop_screens/footer_component/Footer_component";
import images from "../../../../../../utilities/images/images";

const TutorSession = ({ location }) => {
  const sessionUrl = location.state?.sessionUrl || "";

  const history = useHistory();
  const handleBackClick = () => {
    history.push("/doubts");
  };

  return (
    <>
      <Header_component />

      <div
        style={{
          paddingRight: "116px",
          paddingLeft: "116px",
          paddingTop: "100px",
          paddingBottom: "100px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "8px",
          }}
        >
          <img
            src={images.leftArrow}
            alt="Back"
            style={{ width: "38px", height: "38px", cursor: "pointer" }}
            onClick={handleBackClick}
          />
          <button
            style={{
              padding: "0.5rem 0.625rem",
              borderRadius: "0.25rem",
              background: "#b91311",
              marginLeft: "-7px",
              cursor: "pointer",
              color: "white",
            }}
            onClick={handleBackClick}
          >
            End Session
          </button>
        </div>
        {sessionUrl && (
          <iframe
            src={sessionUrl}
            title="Tutor Session"
            width="100%"
            height="680px"
            allow="camera *;microphone *"
          />
        )}
      </div>
      <Footer_component />
    </>
  );
};

export default withRouter(TutorSession);
